<template>
  <b-input-group>
    <b-form-input
      :id="id"
      v-model="date"
      type="text"
      placeholder="GG/MM/AAAA"
      v-validate="validationRule"
      :name="description"
      :state="stateValidation()"
      aria-describedby="input-date"
      autocomplete="off"
      :formatter="formatter"
      :disabled="disabled"
      @input="onChange"/>
    <b-input-group-append>
      <b-form-datepicker
        v-model="localValue"
        button-only right
        aria-controls="date"
        locale="it-IT" start-weekday="1"
        label-help="Usa le freccette per navigare tra le date"
        :disabled="disabled"
        @context="onContext"/>
    </b-input-group-append>
    <b-form-invalid-feedback id="input-date">
      {{ veeErrors.first(description) }}
    </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import moment from "moment";

export default {
  name: "DatePicker",
  props: {
    value: String,
    id: String,
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    description: String,
    notAfterToday: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  inject: ["parentValidator"],
  created() {
    this.$validator = this.parentValidator
    this.$validator.extend(`dateValidator-${this.id}`, {
      getMessage: () => this.isItalian === false
        ? `Formato data errato`
        : this.isNotAfterToday === false
          ? `La data non può essere superiore a oggi`
          : ``,
      validate: () => this.isItalian && this.isNotAfterToday
    })
    this.validationRule = this.required ? `required|dateValidator-${this.id}` : `dateValidator-${this.id}`
  },
  data: () => ({
    date: '',
    validationRule: ''
  }),
  computed: {
    italianDate () {
      return moment(this.date, 'DD/MM/YYYY')
    },
    isItalian () {
      return this.italianDate.format('DD/MM/YYYY') === this.date
    },
    isNotAfterToday () {
      return (this.notAfterToday === false || this.italianDate.isBefore(moment().add(1, "days")))
    },
    localValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('valueChanged', newValue)
      }
    }
  },
  methods: {
    reset() {
      this.date = null
      this.localValue = null
      this.$validator.reset()
    },
    stateValidation() {
      const ref = this.description
      return this.date !== null && this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated) ? !this.veeErrors.has(ref) : null
    },
    onContext(ctx) {
      if (ctx.selectedDate)
        this.date = moment(ctx.selectedDate).format("DD/MM/YYYY")
    },
    onChange(value) {
      if (value.length === 10) {
        this.localValue = moment(value, 'DD/MM/YYYY').format("YYYY-MM-DD");
      } else if (!this.required && value.length === 0) {
        this.localValue = null
      }
    },
    formatter(value) {
      value = value.replace('//', '/')

      if (value.endsWith('/')) {
        return value.split('/')
        .map(part => part.length === 1 ? `0${part}` : part)
        .join('/')
      }

      if (value.length === 2 || value.length === 5) {
        return value + '/'
      } else {
        return value
      }
    }
  }
}
</script>

<style>
.input-group > .input-group-append:not(:last-child) > .btn-group > .btn {
  border-bottom-right-radius: 4px !important;
  border-top-right-radius: 4px !important;
}
</style>
